var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('l-polyline',{attrs:{"lat-lngs":_vm.latLngList,"color":_vm.$vuetify.theme.currentTheme.error,"weight":5,"opacity":1,"interactive":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }